/**
 * Why `DELETE /user` (exsportia-server `DELETE /users/`) refused, as the locale key to show.
 * 409 `{ reason: 'owner_of_open_venue' }`: the only owner of a venue that is still open, nothing
 * was changed. Anything else (500 `deletion_incomplete`, network) is finished by pressing again.
 */
export type RemoveAccountErrorKey = 'removeAccountErrorOwner' | 'removeAccountErrorRetry'

export const removeAccountErrorKey = (error: unknown): RemoveAccountErrorKey => {
  const response = (error as {response?: {status?: number; data?: {reason?: unknown}}} | null)?.response
  return response?.status === 409 && response.data?.reason === 'owner_of_open_venue'
    ? 'removeAccountErrorOwner'
    : 'removeAccountErrorRetry'
}
